export default "$ yarn add @babel/preset-env -D\n// OR\n$ npm install @babel/preset-env -D\n";